import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Cinta de precios con scroll lateral: top 10 criptos por market cap.
 * variant="fixed"  -> fija bajo la cabecera (landing)
 * variant="static" -> en flujo normal del documento (terminal)
 */
const CryptoTicker = ({ variant = 'fixed' }) => {
  const [prices, setPrices] = useState([]);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const { data } = await axios.get(`${API}/api/ticker`);
        if (Array.isArray(data)) setPrices(data);
      } catch { /* fallback gestionado por el backend */ }
    };
    fetchPrices();
    const interval = setInterval(fetchPrices, 120000);
    return () => clearInterval(interval);
  }, []);

  if (!prices.length) return null;

  const doubled = [...prices, ...prices];
  const positionClass = variant === 'fixed' ? 'fixed top-20 z-40' : 'relative';
  return (
    <div className={`${positionClass} left-0 right-0 overflow-hidden bg-[#0d0d0f] border-b border-gray-800/60 py-2.5`} data-testid="crypto-ticker">
      <div className="ticker-track flex gap-10 whitespace-nowrap">
        {doubled.map((coin, i) => (
          <span key={`${coin.symbol}-${i}`} className="inline-flex items-center gap-2 text-sm">
            {coin.image && <img src={coin.image} alt="" className="w-4 h-4 rounded-full" loading="lazy" />}
            <span className="text-gray-400 font-medium">{coin.symbol}</span>
            <span className="text-white font-semibold">${coin.price >= 1 ? coin.price.toLocaleString('en-US', { maximumFractionDigits: 2 }) : coin.price.toFixed(4)}</span>
            <span className={`text-xs font-medium ${coin.change >= 0 ? 'text-green-400' : 'text-red-400'}`}>
              {coin.change >= 0 ? '+' : ''}{coin.change.toFixed(2)}%
            </span>
          </span>
        ))}
      </div>
      <style>{`
        .ticker-track {
          animation: ticker-scroll 35s linear infinite;
        }
        @keyframes ticker-scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
};

export default CryptoTicker;
